import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Handler from "../../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import Modal from "../../Helpers/Components/Modal"
import Add from "./Add";
import LeadStats from "./LeadStats";
import { DropdownButton, DropdownToggle } from "../../Helpers/Components/Dropdown";
import { toast } from "react-toastify";
import * as bootstrap from "bootstrap";
import Select from 'react-select'
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import ExcelPreview from "../../Helpers/Components/ExcelPreview"

const HEADER_FILL = "1F4E78"
const REMARK_HEADER_FILL = "2E5F8A"
const BAND_FILL = "F7F9FC"
const BORDER = { style: "thin", color: { argb: "FFD9D9D9" } }
const DATE_FORMAT = "dd/mm/yyyy"

const STATUS_STYLES = {
    Converted: { fill: "C6EFCE", font: "000000" },
    Rejected: { fill: "FFC7CE", font: "000000" },
    Following: { fill: "FFEB9C", font: "000000" },
    HFU: { fill: "FFEB9C", font: "000000" },
    RNR: { fill: "F8CBAD", font: "000000" },
    Closed: { fill: "D9E1F2", font: "000000" },
}

const BASE_COLUMNS = [
    { header: "S.NO", key: "sno", width: 7 },
    { header: "NOTES DATE", key: "lastFollowUpDate", width: 20 },
    { header: "REG DATE", key: "date", width: 12, style: { numFmt: DATE_FORMAT } },
    { header: "TEAM", key: "team", width: 16 },
    { header: "SOURCE", key: "source", width: 14 },
    { header: "SOURCE NUMBER", key: "sourceNumber", width: 14 },
    { header: "NAME", key: "name", width: 20 },
    { header: "CONTACT NUMBER", key: "contact", width: 22, style: { numFmt: "@" } },
    { header: "TYPE", key: "type", width: 12 },
    { header: "DAYS", key: "days", width: 8 },
    { header: "REQUIRED DATE", key: "reqDate", width: 14, style: { numFmt: DATE_FORMAT } },
    { header: "STATUS", key: "status", width: 12 },
    { header: "NOTES COUNT", key: "notesCount", width: 14 },
]

const MIN_REMARK_COLUMNS = 5

const List = () => {
    const { pageNo, active } = useParams()
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [custDetails, setCustDetails] = useState([])
    const [addData, setAddData] = useState(false)
    const [leadList, setLeadList] = useState([])
    const [downloadData, setDownloadData] = useState({ open: false, data: {} })
    const [preview, setPreview] = useState({ open: false, leads: [], from: null, to: null, leadName:"" })
    const [downloading, setDownloading] = useState(false)
    const closePreview = () => setPreview({ open: false, leads: [], from: null, to: null, leadName:"" })
    const openDownload = () => setDownloadData({ open: true, data: {} });
    const closeDownload = () => setDownloadData({ open: false, data: {} });
    const cart = localStorage.getItem('filter');
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [total, setTotal] = useState(0)
    const [search, setSearch] = useState(cart ? JSON?.parse(cart)?.search ? JSON?.parse(cart)?.search : "" : "");
    const [appliedSearch, setAppliedSearch] = useState(cart ? JSON?.parse(cart)?.search ? JSON?.parse(cart)?.search : "" : "");
    const setPageNo = (value) => navigate(`/lead/${active}/${value}`)
    const [filter, setFilter] = useState({
        count: cart ? JSON?.parse(cart)?.count ? JSON?.parse(cart)?.count : 10 : 10,
        sortBy: "createdAt",
        sort: false,
        createdBy: cart ? JSON?.parse(cart)?.createdBy ? JSON?.parse(cart)?.createdBy : "All" : "All",
        type: cart ? JSON?.parse(cart)?.type ? JSON?.parse(cart)?.type : "All" : "All",
        followedBy: cart ? JSON?.parse(cart)?.followedBy ? JSON?.parse(cart)?.followedBy : "All" : "All",
        src: cart ? JSON?.parse(cart)?.src ? JSON?.parse(cart)?.src : "All" : "All",
        status: cart ? JSON?.parse(cart)?.status ? JSON?.parse(cart)?.status : "All" : "All"
    })
    const phoneOptions = [
        { label: "6280", value: "9566280480" },
        { label: "6180", value: "9566180480" },
    ]
    const handleKeyDown = (event) => { if (event.key === "Enter") { event.preventDefault(); handleSearch(); } };
    const [checkDate, setCheckDate] = useState(cart ? JSON?.parse(cart)?.checkDate ? JSON?.parse(cart)?.checkDate : "" : "")
    const calendarRef = useRef();
    const [checkDate1, setCheckDate1] = useState(cart ? JSON?.parse(cart)?.checkDate1 ? JSON?.parse(cart)?.checkDate1 : "" : "")
    const calendarRef1 = useRef();
    const handleOpen = () => { if (calendarRef.current) { calendarRef.current.openCalendar(); } };
    const handleOpen1 = () => { if (calendarRef1.current) { calendarRef1.current.openCalendar(); } };
    const exportToExcel = async () => {
        if (!downloadData?.data?.from) return toast.error("From date is required")
        if (!downloadData?.data?.to) return toast.error("To date is required")
        if (downloadData?.data?.to < downloadData?.data?.from) return toast.error("From date must be greater than to date")
        setLoading(true)
        const response = await Handler({ method: "post", url: `/lead/download/lead`, data: downloadData?.data })
        setLoading(false)
        if (!response?.success) {
            toast.error(response?.message)
            return
        }
        const { leads = [] } = response?.data || {}
        if (!leads.length) return toast.error("No leads found for the selected dates")
        setPreview({ open: true, leads, from: downloadData?.data?.from, to: downloadData?.data?.to, leadName: downloadData?.data?.person && leadList?.length && leadList?.find(ele => ele.value === downloadData?.data?.person)?.label ? leadList?.find(ele => ele.value === downloadData?.data?.person)?.label : "All" })
        setDownloadData({ open: false })
    }
    const buildLeadSheet = (leads) => {
        const maxRemarks = Math.max(MIN_REMARK_COLUMNS, leads.reduce((max, lead) => Math.max(max, lead.remarks?.length || 0), 0))
        const remarkColumns = Array.from({ length: maxRemarks }, (_, i) => ([
            { header: `REMARK ${i + 1}`, key: `remark${i + 1}`, width: 28 },
            // { header: `REMARK ${i + 1} STATUS`, key: `remark${i + 1}Status`, width: 18 },
        ])).flat()
        const rows = leads.map((lead) => {
            const row = {
                sno: lead.sno,
                lastFollowUpDate: formatDate(lead.lastFollowUpDate),
                date: formatDate(lead.date),
                team: lead.team || "-",
                source: lead.source || "-",
                sourceNumber: lead.sourceNumber || "-",
                name: lead.name || "-",
                contact: lead.contact || "-",
                type: lead.type || "-",
                days: lead.days === 0 || lead.days ? lead.days : "-",
                reqDate: formatDateOnly(lead.reqDate),
                status: lead.status || "-",
                notesCount: lead.notesCount ?? 0,
            };
            (lead.remarks || []).forEach((remark, i) => {
                row[`remark${i + 1}`] = [remark?.date ? formatDate(remark?.date) : "", remark?.note || ""].filter(Boolean).join(" - ") + (remark?.by ? ` (${remark.by})` : "")
                // row[`remark${i + 1}Status`] = remark?.remark || "-"
            })
            return row
        })
        return { columns: [...BASE_COLUMNS, ...remarkColumns], remarkColumns, rows }
    }
    const downloadExcel = async () => {
        setDownloading(true)
        const { columns, remarkColumns, rows } = buildLeadSheet(preview.leads)
        const workbook = new ExcelJS.Workbook()
        workbook.creator = "Monter"
        workbook.created = new Date()
        const sheet = workbook.addWorksheet("Leads", {
            views: [{ state: "frozen", ySplit: 1 }],
        })
        sheet.columns = columns
        rows.forEach((row) => sheet.addRow(row))
        styleHeaderRow(sheet, BASE_COLUMNS.length)
        styleDataRows(sheet, { statusColumn: "status" })
        sheet.autoFilter = { from: "A1", to: `${sheet.getColumn(sheet.columns.length).letter}1` }
        for (let i = 0; i < remarkColumns.length; i++) {
            sheet.getColumn(BASE_COLUMNS.length + 1 + i).alignment = { wrapText: true, vertical: "top" }
        }
        const buffer = await workbook.xlsx.writeBuffer()
        saveAs(new Blob([buffer], { type: fileType }), `Lead ${moment(new Date(preview.from))?.format("DD/MM/YYYY")}${new Date(preview.from) < new Date(preview.to) ? `- ${moment(new Date(preview.to))?.format("DD/MM/YYYY")}` : ""}` + fileExtension)
        setDownloading(false)
    }
    function formatDate(date) {
        if (!date) {
            return "-"
        }
        const d = new Date(date);

        const pad = (num) => String(num).padStart(2, "0");

        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = pad(d.getMinutes());

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${day}/${month}/${year} - ${pad(hours)}:${minutes} ${ampm}`;
    }

    const formatDateOnly = (date) => {
        if (!date) {
            return "-"
        }
        const d = new Date(date);

        const pad = (num) => String(num).padStart(2, "0");

        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();


        return `${day}/${month}/${year}`;
    }

    function styleHeaderRow(sheet, baseColumnCount) {
        const header = sheet.getRow(1)
        header.height = 22
        header.eachCell((cell, colNumber) => {
            const isRemarkCol = colNumber > baseColumnCount
            cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 }
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: `FF${isRemarkCol ? REMARK_HEADER_FILL : HEADER_FILL}` },
            }
            cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true }
            cell.border = { top: BORDER, left: BORDER, bottom: BORDER, right: BORDER }
        })
    }

    function styleDataRows(sheet, { statusColumn } = {}) {
        const statusColIndex = statusColumn ? sheet.getColumn(statusColumn).number : null

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) return

            const isBanded = rowNumber % 2 === 0
            const statusValue = statusColIndex ? row.getCell(statusColIndex).value : null
            const statusStyle = STATUS_STYLES[statusValue]

            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = { top: BORDER, left: BORDER, bottom: BORDER, right: BORDER }
                cell.alignment = { ...cell.alignment, vertical: "middle" }

                if (statusStyle) {
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: `FF${statusStyle.fill}` } }
                    cell.font = { color: { argb: `FF${statusStyle.font}` }, bold: colNumber === statusColIndex }
                } else {
                    cell.font = { color: { argb: "FF000000" } }
                    if (isBanded) cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: `FF${BAND_FILL}` } }
                }
            })
        })
    }
    const handleSearch = () => {
        setPageNo(1);
        setAppliedSearch(search);
    };
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({
            ...prev,
            sortBy: sortBy,
            sort: sort
        }))
    }
    const handleChange = (e) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        setItem(e.target.name, e.target.value);
    }
    const getLeadDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/lead/list/${active}/${pageNo}?count=${filter?.count || 10}`,
            data: {
                ...(appliedSearch ? { search: appliedSearch } : {}),
                ...(checkDate?.length ? { from: moment(new Date(checkDate[0]))?.format("DD-MM-YYYY"), to: checkDate?.length >= 2 ? moment(new Date(checkDate[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate[0]))?.format("DD-MM-YYYY") } : {}),
                ...(checkDate1?.length ? { followFrom: moment(new Date(checkDate1[0]))?.format("DD-MM-YYYY"), followTo: checkDate1?.length >= 2 ? moment(new Date(checkDate1[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate1[0]))?.format("DD-MM-YYYY") } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy,
                ...(filter?.followedBy !== "All" ? { followedBy: filter?.followedBy } : {}),
                ...(filter?.type !== "All" ? { type: filter?.type } : {}),
                ...(filter?.src !== "All" ? { src: filter?.src } : {}),
                ...(filter?.status !== "All" ? { status: filter?.status } : {})
            }
        })
        if (response?.success) {
            setCustDetails(response?.data?.current)
            setNext(response?.data?.next)
            setTotal(response?.data?.total)
        } else {
            setCustDetails([])
            setNext(false)
            setTotal(0)
        }
        setLoading(false)
    }
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            setLeadList([...(response?.data?.length ? response?.data?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
        } else {
            setLeadList([])
        }
    }
    const shortText = (text, limit = 30) => {
        if (!text) return "";
        return text.length > limit ? text.slice(0, limit) + "..." : text;
    };
    const clearFilter = () => {
        setSearch("");
        setAppliedSearch("");
        setFilter({ count: 10, sortBy: "createdAt", sort: false, search: "", type: "All", remarks: "All", followedBy: "All", src: "All", status: "All" })
        setCheckDate1({})
        setCheckDate({})
        localStorage.removeItem('filter')
        setPageNo(1)
    }
    const setItem = (name, value) => {
        const existing = localStorage.getItem('filter');
        let oldData = existing ? JSON.parse(existing) : {};
        oldData[name] = value || "";
        localStorage.setItem('filter', JSON.stringify(oldData));
    };
    const applyQuickFilter = (type) => {
        const today = [new Date(), new Date()];
        switch (type) {
            case "todayTotal":
                navigate(`/lead/all/1`);
                setCheckDate1({});
                setItem('checkDate1', '');
                setCheckDate(today);
                setItem('checkDate', today);
                break;
            case "todayConverted":
                navigate(`/lead/converted/1`);
                setCheckDate1({});
                setItem('checkDate1', '');
                setCheckDate(today);
                setItem('checkDate', today);
                break;
            case "todayRejected":
                navigate(`/lead/rejected/1`);
                setCheckDate1({});
                setItem('checkDate1', '');
                setCheckDate(today);
                setItem('checkDate', today);
                break;
            case "todayFollowUps":
                navigate(`/lead/following/1`);
                setCheckDate({});
                setItem('checkDate', '');
                setCheckDate1(today);
                setItem('checkDate1', today);
                break;
            default:
                break;
        }
    };
    const handleFilter = (name, value) => {
        setFilter((prev) => ({ ...prev, [name]: value }))
        setItem(name, value)
        setPageNo(1)
    }
    useEffect(() => {
        getLeadList()
    }, [])
    useEffect(() => {
        getLeadDetails()
    }, [pageNo, filter, checkDate, checkDate1, appliedSearch, active])
    useEffect(() => {
        let activePopover = null;
        const triggers = document.querySelectorAll('[data-bs-toggle="popover"]');
        triggers.forEach((el) => {
            const popover = bootstrap.Popover.getOrCreateInstance(el, { trigger: "focus", });
            el.addEventListener("click", () => {
                if (activePopover && activePopover !== popover) activePopover.hide();
                activePopover = popover;
            });
        });
    }, [custDetails]);
    return (
        <React.Fragment>
            <Modal header={"New Member"} size={"lg"} onShow={addData} toggle={() => setAddData(!addData)} overlayToggle={() => setAddData(!addData)}><Add /></Modal>
            <h5 className="text-center text-theme fs-4">Lead List</h5>
            <LeadStats onQuickFilter={applyQuickFilter} />
            <div className="layout-card mt-2">
                <div className="row justify-content-between align-items-center mb-3">
                    <div className="col-lg-8">
                        <ul className="nav nav-underline">
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "all" ? "active-tabs" : ""}`} aria-current="page" href="/lead/all/1">All</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "mylead" ? "active-tabs" : ""}`} aria-current="page" href="/lead/mylead/1">My Leads</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "following" ? "active-tabs" : ""}`} aria-current="page" href="/lead/following/1">Following</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "rejected" ? "active-tabs" : ""}`} aria-current="page" href="/lead/rejected/1">Rejected</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "converted" ? "active-tabs" : ""}`} aria-current="page" href="/lead/converted/1">Converted</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "upcoming" ? "active-tabs" : ""}`} aria-current="page" href="/lead/upcoming/1">Upcoming</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "missed" ? "active-tabs" : ""}`} aria-current="page" href="/lead/missed/1">Missed</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${active === "customers" ? "active-tabs" : ""}`} aria-current="page" href="/lead/customers/1">Customers</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-4 d-flex justify-content-end gap-3 align-items-center">
                        <button className="btn btn-theme mt-lg-0 mt-3" onClick={() => { setAddData(!addData) }} >Register</button>
                        <button className="btn p-0 border-0 d-flex" onClick={openDownload} disabled={loading}> <i className="fa-solid fa-download fs-5"></i> </button>
                    </div>
                </div>
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center gap-2">
                            <div className="input-group">
                                <input type="text" className="form-control search-input" onKeyDown={handleKeyDown} autoComplete="off" placeholder="Search..." value={search} onChange={(e) => { setItem("search", e.target.value); if (e.target.value) setSearch(e.target.value); else { setSearch(""); setAppliedSearch(""); setPageNo(1); } }} name="search" />
                                <span className="input-group-text cancel-icon">{search && (<i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setSearch(""); setAppliedSearch(""); setPageNo(1); }} />)}</span>
                            </div>
                            <button className="btn btn-sm btn-theme" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                </div>
                <div className="fw-bold d-flex align-items-center flex-wrap gap-3 mt-3">Total Count : {total || 0} <button onClick={clearFilter} className="btn btn-theme btn-sm">Clear Filter</button></div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "createdAt" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("createdAt", false)} >▲</i><i className={filter?.sortBy === "createdAt" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("createdAt", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Reg Date</button> </div></th>
                                <th>
                                    <DropdownToggle label={<>Phone & Type <i className="fa-solid fa-caret-down"></i></>}>
                                        <DropdownButton label="All" className={`${filter?.type === "All" ? "active-option" : ""}`} onClick={() => { handleFilter("type", "All") }} />
                                        <DropdownButton label="NRI" className={`${filter?.type === "nri" ? "active-option" : ""}`} onClick={() => { handleFilter("type", "nri") }} />
                                        <DropdownButton label="Local" className={`${filter?.type === "local" ? "active-option" : ""}`} onClick={() => { handleFilter("type", "local") }} />
                                        <DropdownButton label="Foreigner" className={`${filter?.type === "foreigner" ? "active-option" : ""}`} onClick={() => { handleFilter("type", "foreigner") }} />
                                    </DropdownToggle>
                                </th>
                                <th>Car Req</th>
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "followUp" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("followUp", false)} >▲</i><i className={filter?.sortBy === "followUp" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("followUp", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen1() }}>Follow Up</button> </div></th>
                                <th>
                                    <DropdownToggle label={<>Src <i className="fa-solid fa-caret-down"></i></>}>
                                        <DropdownButton label="All" className={`${filter?.src === "All" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "All") }} />
                                        <DropdownButton label="DC" className={`${filter?.src === "DC" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "DC") }} />
                                        <DropdownButton label="WA" className={`${filter?.src === "WA" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "WA") }} />
                                        <DropdownButton label="LC" className={`${filter?.src === "LC" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "LC") }} />
                                        <DropdownButton label="Walk-in" className={`${filter?.src === "Walk-in" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "Walk-in") }} />
                                        <DropdownButton label="Ref" className={`${filter?.src === "Ref" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "Ref") }} />
                                        <DropdownButton label="Other" className={`${filter?.src === "Other" ? "active-option" : ""}`} onClick={() => { handleFilter("src", "Other") }} />
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={<>Followed By <i className="fa-solid fa-caret-down"></i></>}>
                                        <DropdownButton label="All" className={`${filter?.followedBy === "All" ? "active-option" : ""}`} onClick={() => { handleFilter("followedBy", "All") }} />
                                        {
                                            leadList?.length ?
                                                leadList?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.followedBy === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { handleFilter("followedBy", element?.value) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>Last Note</th>
                                <th>
                                    <DropdownToggle label={<>Status <i className="fa-solid fa-caret-down"></i></>}>
                                        <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "All") }} />
                                        <DropdownButton label="Lead" className={`${filter?.status === "Lead" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "Lead") }} />
                                        <DropdownButton label="Following" className={`${filter?.status === "Following" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "Following") }} />
                                        <DropdownButton label="HFU" className={`${filter?.status === "HFU" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "HFU") }} />
                                        <DropdownButton label="RNR" className={`${filter?.status === "RNR" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "RNR") }} />
                                        <DropdownButton label="Rejected" className={`${filter?.status === "Rejected" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "Rejected") }} />
                                        <DropdownButton label="Closed" className={`${filter?.status === "Closed" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "Closed") }} />
                                        <DropdownButton label="Converted" className={`${filter?.status === "Converted" ? "active-option" : ""}`} onClick={() => { handleFilter("status", "Converted") }} />
                                    </DropdownToggle>
                                </th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${value?.status === "Rejected" ? "text-red" : (value?.status === "Converted" ? "text-success" : "")}`}>
                                            <td>
                                                <div className="d-flex flex-column">
                                                    <span className="text-capitalize">{value?.createdBy || ""}</span>
                                                    <span className="text-capitalize">{value?.createdAt || value?.registerDate ? moment(value?.registerDate || value?.createdAt).format('DD/MM/YYYY') : ""}</span>
                                                    <span className="text-capitalize">{value?.createdAt || value?.registerDate ? moment(value?.registerDate || value?.createdAt).format('hh:mm A') : ""}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column"><span className="text-capitalize">{(value?.name || "")}</span><span>{(value?.code || "") + (value?.phone || "")}</span>
                                                    <span className="text-uppercase">{value?.type || ""}</span></div>
                                            </td>
                                            <td>{value?.carReq ? moment(new Date(value?.carReq)).format("DD/MM/YYYY") : ""}</td>
                                            <td>{value?.notes?.length ? (value?.notes[value?.notes?.length - 1]?.followUp ? moment(value?.notes[value?.notes?.length - 1]?.followUp).format("DD/MM/YYYY") : "") : ""}</td>
                                            <td> <div className="d-flex flex-column"> <span>{value?.src || ""}</span><span>{value?.srcNumber ? phoneOptions?.find(ele => ele.value === value?.srcNumber)?.label : ""}</span></div></td>
                                            <td className="text-capitalize">{value?.followedBy || ""}</td>
                                            <td className="text-capitalize">
                                                {
                                                    value?.notes?.length ?
                                                        <button className="p-o border-0 btn" type="button" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" data-bs-title="Details" data-bs-content={value?.notes[value?.notes?.length - 1]?.note}> ({value?.notes?.length || 0}) {shortText(value?.notes[value?.notes?.length - 1]?.note, 10)} </button>
                                                        : ""
                                                }
                                            </td>
                                            <td>{value?.status || ""}</td>
                                            <td className="text-center">
                                                {/* <i className="fa-solid fa-pen-to-square fs-5 me-2 cursor-pointer" onClick={() => { setDetail(value); setEditData(true) }}></i> */}
                                                <i className="fa-solid fa-eye fs-5 me-2 cursor-pointer" onClick={() => { navigate(`/lead/${value?.leadId}`) }}></i>
                                                {/* <i className="fa-solid fs-5 fa-notes-medical cursor-pointer" onClick={() => viewModal(value?.leadId)}></i> */}
                                            </td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={9}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={9} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            handleFilter("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue={`lead/${active}`} />
            </div>
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); setItem("checkDate", e) } }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => { setCheckDate({}); setItem("checkDate", "") },
                    },
                ]}
            />
            <DatePicker
                ref={calendarRef1}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate1(e); setItem("checkDate1", e) } }}
                value={checkDate1}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => { setCheckDate1({}); setItem("checkDate1", "") },
                    },
                ]}
            />
            <Modal header="Download" centered={true} onShow={downloadData?.open} toggle={closeDownload} overlayToggle={closeDownload} >
                <div className="text-center" >
                    <div className="mb-3 text-start">
                        <label htmlFor="downloadFrom" className="form-label">From</label>
                        {/* <input
                            type="datetime-local"
                            className="form-control"
                            id="downloadFrom"
                            value={downloadData?.data?.from || ""}
                            max={downloadData?.data?.to || undefined}
                            onChange={}
                        /> */}
                        <div className="filter-date datepicker-top">  <DatePicker portal zIndex={2000} disabled={loading} value={downloadData?.data?.from ? new Date(downloadData?.data?.from) : ""} format="DD/MM/YYYY" onChange={(e) => setDownloadData({ ...downloadData, data: { ...downloadData?.data, from: new Date(e), to: '' } })} />
                        </div></div>
                    <div className="mb-3 text-start">
                        <label htmlFor="downloadTo" className="form-label">To</label>
                        {/* <input
                            type="datetime-local"
                            className="form-control"
                            id="downloadTo"
                            value={downloadData?.data?.to || ""}
                            min={downloadData?.data?.from || undefined}
                            onChange={(e) => setDownloadData({ ...downloadData, data: { ...downloadData?.data, to: e.target.value } })}
                        /> */}
                        <div className="filter-date datepicker-top">      <DatePicker minDate={new Date(new Date(downloadData?.data?.from)?.setHours(new Date(downloadData?.data?.from)?.getHours() - 1))} portal zIndex={2000} disabled={loading || !downloadData?.data?.from} value={downloadData?.data?.to ? new Date(downloadData?.data?.to) : ""} format="DD/MM/YYYY" onChange={(e) => setDownloadData({ ...downloadData, data: { ...downloadData?.data, to: new Date(e) } })} />
                        </div>
                    </div>
                    <div className="mb-3 text-start">
                        <label htmlFor="downloadPerson" className="form-label">Person</label>
                        <select
                            className="form-select"
                            id="downloadPerson"
                            value={downloadData?.data?.person || "all"}
                            onChange={(e) => setDownloadData({ ...downloadData, data: { ...downloadData?.data, person: e.target.value } })}
                        >
                            <option value="all">All</option>
                            {
                                leadList?.length ? leadList?.map((val, i) => (
                                    <option key={i} value={val?.value}>{val?.label}</option>
                                )) : ""
                            }
                        </select>
                    </div>
                    <button className="btn btn-success" onClick={exportToExcel} disabled={loading}>{loading ? "Loading..." : "Submit"}</button>
                </div>
            </Modal>

            <Modal header="Excel Preview" fullScreen={true} onShow={preview.open} toggle={closePreview} overlayToggle={closePreview}>
                {preview.open ?
                    <ExcelPreview {...buildLeadSheet(preview.leads)}
                        summary={`${preview.leads.length} leads · ${moment(new Date(preview.from)).format("DD/MM/YYYY")} to ${moment(new Date(preview.to)).format("DD/MM/YYYY")} · ${preview?.leadName || "All"}`} onDownload={downloadExcel} downloading={downloading} getRowFill={(row) => STATUS_STYLES[row.status]?.fill} /> : null}
            </Modal>
        </React.Fragment>
    )
}

export default List;